(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('chartsService', ['moment','$rootScope', 
            function (moment, $rootScope) {

                function setColor(color){
                        return {
                            backgroundColor : color,
                            pointBackgroundColor: color,
                            pointHoverBackgroundColor: color,
                            borderColor: color,
                            pointBorderColor: color,
                            pointHoverBorderColor: color,
                            fill: false
                        };
                }

                function addMissingDates(diff, lastDate, labels, variableData, variableSum){

                        if(diff>1){
                            for(var i = 1; i < diff; i++){
                                if(fac.data.by == 'hour'){
                                    lastDate.setTime(lastDate.getTime() + 60 * 60 * 1000);
                                    labels.push(lastDate.toLocaleTimeString());
                                }
                                else if(fac.data.by == 'day'){
                                    lastDate.setTime(lastDate.getTime() + 24 * 60 * 60 * 1000);
                                    labels.push(lastDate.toLocaleDateString());
                                }
                                else if(fac.data.by == 'month'){
                                    lastDate.setMonth( lastDate.getMonth( ) + 1 );
                                    labels.push((lastDate.getMonth()+1+'/'+lastDate.getFullYear()));
                                }
                                else if(fac.data.by == 'year'){
                                    lastDate.setFullYear( lastDate.getFullYear( ) + 1 );
                                    labels.push(lastDate.getFullYear());
                                }

                                
                                for(var index in fac.variables){
                                    var variable = fac.variables[index];
                                    if(variable.indexOf('.') != -1){
                                        if(!variableData[variable]){
                                            variableData[variable] = [];
                                        }
                                        if(variableSum[variable] === undefined){
                                            variableSum[variable] = 0;
                                        }
                                        variableData[variable].push(0);
                                        variableSum[variable] = variableSum[variable];

                                    }
                                    else{
                                        if(!variableData[variable]){
                                            variableData[variable] = [];
                                        }
                                        if(variableSum[variable] === undefined){
                                            variableSum[variable] = 0;
                                        }
                                        variableData[variable].push(0);
                                        variableSum[variable] = variableSum[variable];
                                    }
                                }
                            }
                        }
                }

                function diffBeetweenDates(d1, d2){
                    if(fac.data.by == 'hour'){
                        return (d2.getTime() - d1.getTime()) / (60 * 60 * 1000);
                    }
                    else if(fac.data.by == 'day'){
                        return (d2.getTime() - d1.getTime()) / (24 * 60 * 60 * 1000);
                    }
                    else if(fac.data.by == 'month'){
                        var months = (d2.getFullYear() - d1.getFullYear()) * 12;
                        months -= d1.getMonth() + 1;
                        months += d2.getMonth();
                        return months;
                    }
                    else if(fac.data.by == 'year'){
                        return d2.getFullYear() - d1.getFullYear();
                    }
                }
                var fac = {
                    colors: [],
                    series: [],
                    variables: [],
                    defaultVariables: [],
                    getSampling: getSampling,
                    separateData: separateData,
                    setData: setData,
                    displayVariables: displayVariables,
                    selectedDateRange: function(_selectedDateRange, query, getData){
                        var selectedDateRange = {
                            get: function () {
                                return _selectedDateRange;
                            },

                            set: function (value) {
                                _selectedDateRange = value;
                                switch (value) {
                                    case "Today":
                                        query.from.value = moment().startOf('day').toDate();
                                        query.to.value = moment().toDate();
                                        break;
                                    case "Yesterday":
                                        query.from.value = moment().startOf('day').subtract(1, 'days').toDate();
                                        query.to.value = moment().startOf('day').toDate();
                                        break;
                                    case "7Days":
                                        query.from.value = moment().startOf('week').toDate();
                                        query.to.value = moment().toDate();
                                        break;
                                    case "Last7Days":
                                        query.from.value = moment().startOf('week').subtract(1, 'weeks').toDate();
                                        query.to.value = moment().startOf('week').toDate();
                                        break;
                                    case "30Days":
                                        query.from.value = moment().startOf('month').toDate();
                                        query.to.value = moment().toDate();
                                        break;
                                    case "Last30Days":
                                        query.from.value = moment().startOf('month').subtract(1, 'months').toDate();
                                        query.to.value = moment().startOf('month').toDate();
                                        break;
                                    case "Year":
                                        query.from.value = moment().startOf('year').toDate();
                                        query.to.value = moment().toDate();
                                        break;
                                    case "LastYear":
                                        query.from.value = moment().startOf('year').subtract(1, 'years').toDate();
                                        query.to.value = moment().startOf('year').toDate();
                                        break;
                                }
                                getData();
                              
                            
                                
                            }
                        };
                        return selectedDateRange;
                    },
                    setVariables: function(variables){
                        fac.colors = [];
                        fac.series = [];
                        fac.variables = [];
                        fac.defaultVariables = variables;
                        for(var i in variables){
                            var variable = variables[i];
                            fac.colors.push(setColor(variable.color));
                            fac.series.push(variable.displayName);
                            fac.variables.push(variable.name);
                        }
                    },
                    data: {},
                    datasetOverride: function(){
                        var ret = [];
                        for(var i=0;i<fac.colors.length;i++){
                            ret.push({ yAxisID: 'y-axis-1', pointRadius: 1, pointHoverRadius: 2, pointHitRadius: 1 });
                        }
                        return ret;
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                }
                            }],
                            yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                gridlines: {
                                    display: false
                                },
                                ticks: {
                                    beginAtZero: true,
                                    maxTicksLimit: 10,
                                    callback: function (tick, index, ticks) {
                                        if (tick.toString().indexOf('.') !== -1)
                                            return null;

                                        return tick.toLocaleString();
                                    }
                                },
                                display: true,
                                position: 'left'
                            }]
                        }
                    }
                };

                return fac;
                function displayVariables (varIndex, allData){
                        if(varIndex || varIndex === 0) fac.defaultVariables[varIndex].display = !fac.defaultVariables[varIndex].display;
                        var data = [];
                        var series = [];
                        var colors = [];
                        for(var index in fac.defaultVariables){
                            var variable = fac.defaultVariables[index];
                            if(variable.display) {
                                series.push(fac.series[index]);
                                data.push(allData[index]);
                                colors.push(fac.colors[index]);
                            }
                        }
                        return {series: series, data: data, colors: colors};
                }
                function setData(from, to, system, by){
                    if(!moment(to.value).isSame(moment(), 'day')){
                        to.value = moment(to.value).endOf('day').toDate();
                    }
                   
                    else if(!moment(to.value).isSame(moment(), 'second')){
                        to.value = new Date();
                    }
                    if (moment(from.value).isSame(moment(), 'day')) {
                        from.value = moment(from.value).startOf('day').toDate();
                    }
                    if (system && system != 'all') {
                        fac.data = {
                            from: from,
                            to: to,
                            system: system,
                            by: by ? by : 'day'
                        };
                    } else {
                        fac.data = {
                            from: from,
                            to: to,
                            by: by ? by : 'day'
                        };
                    }
                 
                }
                function separateData(result){
                    var lastDate =  angular.copy(fac.data.from.value);
                    var variableData = [], labels = [], variableSum = [];
                    result.forEach(function (item) {
                        var date = new Date(item.date);
                        var diff = diffBeetweenDates(lastDate, date);
                        addMissingDates(diff, lastDate, labels, variableData, variableSum);
                        if(fac.data.by == 'hour'){
                            labels.push(date.toLocaleTimeString());
                        }
                        else if(fac.data.by == 'day'){
                            labels.push(date.toLocaleDateString());
                        }
                        else if(fac.data.by == 'month'){
                            labels.push(date.getMonth()+1+'/'+date.getFullYear());
                        }
                        else if(fac.data.by == 'year'){
                            labels.push(date.getFullYear());
                        }
                        lastDate = date;
                        for(var index in fac.variables){
                            var variable = fac.variables[index];
                            if(variable.indexOf('.') != -1){
                                var splitVariable = variable.split('.');
                                var subItem = item;
                                var i;
                                for(i in splitVariable){
                                    if(subItem) subItem = subItem[[splitVariable[i]]];
                                }
                                if(!variableData[variable]){
                                    variableData[variable] = [];
                                }
                                if(variableSum[variable] === undefined){
                                    variableSum[variable] = 0;
                                }
                                if(!subItem){
                                    subItem = 0;
                                }
                                variableData[variable].push(subItem);
                                variableSum[variable] = variableSum[variable] + subItem;

                            }
                            else{
                                var subItem = item[variable];
                                if(!variableData[variable]){
                                    variableData[variable] = [];
                                }
                                if(variableSum[variable] === undefined){
                                    variableSum[variable] = 0;
                                }
                                if(!subItem){
                                    subItem = 0;
                                }
                                variableData[variable].push(subItem);
                                variableSum[variable] = variableSum[variable] + subItem;
                            }
                        }
                    });
                    var endDiff = diffBeetweenDates(lastDate, fac.data.to.value);
                    addMissingDates(endDiff, lastDate, labels, variableData, variableSum);
                    return {
                        labels: labels,
                        variableData: variableData,
                        variableSum: variableSum
                    };
                }

                function getSampling(skipHours){
                    var days = (fac.data.to.value.getTime() - fac.data.from.value.getTime())/(24 * 60 * 60 * 1000);
                    if (days<=1){
                        if(!skipHours){
                            fac.data.by = 'hour';
                        }
                        else{
                            fac.data.by = 'day';
                        }
                    }
                    else if (days<180 && days>=1){
                        fac.data.by = 'day';
                    }
                    else if (days>=180 && days<1095){
                        fac.data.by = 'month';
                    }
                    else{
                        fac.data.by = 'year';
                    }
                    return fac.data.by;
                }
                
            }
        ]);
})(window.angular);